import { Github, Instagram, Linkedin, Mail, SquareArrowOutUpRight, Terminal } from "lucide-react";
import { useLoaderData, type LinksFunction, type LoaderFunction, type MetaFunction } from "react-router";
// import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button";

const name = "Richard Cotrina";
const linkedinURL = "https://www.linkedin.com/in/rcotrina94?source=rcotrina.dev"
// const title = "software developer";
const titledTitle = "Software Developer";

export const meta: MetaFunction = () => {
  return [
    { title: [name, titledTitle].join(" | ") },
    {
      name: "description",
      // content: "Portafolio personal y profesional donde comparto mis contribuciones en áreas clave como desarrollo de software para empresas (ERP, e-commerce, salud digital), robótica, IoT, ciberseguridad, DevOps, impresión 3D y bioinformática. Explora mis proyectos innovadores y experiencias transformadoras en tecnología."
      content: "Portafolio y experiencias en proyectos de áreas clave en diversas industrias.",
      keywords: "portafolio, portfolio, developer, software, desarrollador, ERP, e-commerce, ecommerce, digital, salud digital, digital health, robótica, robotics, IoT, ciberseguridad, cibersecurity, devops, 3D, 3D printing, impresión 3D, bioinformática, proyectos innovadores, Perú, Peru"
    },
  ];
};

export const links: LinksFunction = () => [
  {
    rel: "canonical",
    href: "https://rcotrina.dev/",
  },
]

export const loader: LoaderFunction = async ({ request }) => {
  const referer = request.headers.get("referer");

  if (referer?.includes("google.com")) {
    const url = new URL(referer);
    const searchTerm = url.searchParams.get("q");
    console.log("Término de búsqueda:", searchTerm);
    return { referer, searchTerm }
  }

  return { referer };
};


export default function Index() {

  const data = useLoaderData<typeof loader>()
  const st = JSON.stringify(data)
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
      <div className="w-full max-w-xs">
        <div className="hidden">
          <code dangerouslySetInnerHTML={{ __html: st }}>

          </code>
        </div>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col items-center gap-2">
              <a
                href="/"
                className="flex flex-col items-center font-medium pb-2"
              >
                <div className="flex h-8 w-8 items-center justify-center rounded-md">
                  <Terminal className="size-6" />
                </div>
                <span className="sr-only">{name}</span>
              </a>
              {/* <h1 className="text-center text-sm">
                ¡Hola, tú! 👋
              </h1> */}
              <h2 className="text-3xl font-bold">{name}</h2>
              <h1 className="text-center text-lg">
                {titledTitle}
              </h1>
              <div className="mt-4">
                <Button asChild variant="outline">
                  <a href={linkedinURL} className="relative inline-flex">
                    <SquareArrowOutUpRight /> Disponible actualmente
                    <span className="pointer-events-none flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-teal-500"></span>
                    </span>
                  </a>
                </Button>
              </div>
              <div className="mt-2">
                <Button asChild variant="outline">
                  <a href="/cv" className="relative inline-flex">
                    <SquareArrowOutUpRight /> Ver CV
                  </a>
                </Button>
              </div>
            </div>
            <div className="relative after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
              {/* <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
                <span className="relative z-10 bg-background px-2 text-muted-foreground text-xs">
                  encuéntrame en:
                </span>
              </div> */}
            </div>
            <div className="flex gap-4 justify-center">
              <Button asChild variant="outline" className="w-8 h-8">
                <a title="E-mail" href={"mailto:jobs@rcotrina.dev"}>
                  <Mail />
                  <span className="sr-only">Envíame un correo</span>
                </a>
              </Button>
              <Button asChild variant="outline" className="w-8 h-8">
                <a title="Github" href={"https://github.com/rcotrina94"}>
                  <Github />
                  <span className="sr-only">Visita mi perfil de GitHub</span>
                </a>
              </Button>
              <Button asChild variant="outline" className="w-8 h-8">
                <a title="LinkedIn" href={linkedinURL}>
                  <Linkedin />
                  <span className="sr-only">Visita mi perfil de LinkedIn</span>
                </a>
              </Button>
              <Button asChild variant="outline" className="w-8 h-8">
                <a title="Instagram" href={"https://www.instagram.com/rcotrina94"}>
                  <Instagram />
                  <span className="sr-only">Visita mi perfil de Instagram</span>
                </a>
              </Button>
            </div>
            {/*
            <div className="grid gap-4 sm:grid-cols-2">
              <Button variant="outline" className="w-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
                    fill="currentColor"
                  />
                </svg>
                Continue with Apple
              </Button>
              <Button variant="outline" className="w-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
                    fill="currentColor"
                  />
                </svg>
                Continue with Google
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

// const resources = [
//   {
//     href: "https://remix.run/start/quickstart",
//     text: "Quick Start (5 min)",
//     icon: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         className="stroke-gray-600 group-hover:stroke-current dark:stroke-gray-300"
//       >
//         <path
//           d="M8.51851 12.0741L7.92592 18L15.6296 9.7037L11.4815 7.33333L12.0741 2L4.37036 10.2963L8.51851 12.0741Z"
//           strokeWidth="1.5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     href: "https://remix.run/start/tutorial",
//     text: "Tutorial (30 min)",
//     icon: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         className="stroke-gray-600 group-hover:stroke-current dark:stroke-gray-300"
//       >
//         <path
//           d="M4.561 12.749L3.15503 14.1549M3.00811 8.99944H1.01978M3.15503 3.84489L4.561 5.2508M8.3107 1.70923L8.3107 3.69749M13.4655 3.84489L12.0595 5.2508M18.1868 17.0974L16.635 18.6491C16.4636 18.8205 16.1858 18.8205 16.0144 18.6491L13.568 16.2028C13.383 16.0178 13.0784 16.0347 12.915 16.239L11.2697 18.2956C11.047 18.5739 10.6029 18.4847 10.505 18.142L7.85215 8.85711C7.75756 8.52603 8.06365 8.21994 8.39472 8.31453L17.6796 10.9673C18.0223 11.0653 18.1115 11.5094 17.8332 11.7321L15.7766 13.3773C15.5723 13.5408 15.5554 13.8454 15.7404 14.0304L18.1868 16.4767C18.3582 16.6481 18.3582 16.926 18.1868 17.0974Z"
//           strokeWidth="1.5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     href: "https://remix.run/docs",
//     text: "Remix Docs",
//     icon: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         className="stroke-gray-600 group-hover:stroke-current dark:stroke-gray-300"
//       >
//         <path
//           d="M9.99981 10.0751V9.99992M17.4688 17.4688C15.889 19.0485 11.2645 16.9853 7.13958 12.8604C3.01467 8.73546 0.951405 4.11091 2.53116 2.53116C4.11091 0.951405 8.73546 3.01467 12.8604 7.13958C16.9853 11.2645 19.0485 15.889 17.4688 17.4688ZM2.53132 17.4688C0.951566 15.8891 3.01483 11.2645 7.13974 7.13963C11.2647 3.01471 15.8892 0.951453 17.469 2.53121C19.0487 4.11096 16.9854 8.73551 12.8605 12.8604C8.73562 16.9853 4.11107 19.0486 2.53132 17.4688Z"
//           strokeWidth="1.5"
//           strokeLinecap="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     href: "https://rmx.as/discord",
//     text: "Join Discord",
//     icon: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="20"
//         viewBox="0 0 24 20"
//         fill="none"
//         className="stroke-gray-600 group-hover:stroke-current dark:stroke-gray-300"
//       >
//         <path
//           d="M15.0686 1.25995L14.5477 1.17423L14.2913 1.63578C14.1754 1.84439 14.0545 2.08275 13.9422 2.31963C12.6461 2.16488 11.3406 2.16505 10.0445 2.32014C9.92822 2.08178 9.80478 1.84975 9.67412 1.62413L9.41449 1.17584L8.90333 1.25995C7.33547 1.51794 5.80717 1.99419 4.37748 2.66939L4.19 2.75793L4.07461 2.93019C1.23864 7.16437 0.46302 11.3053 0.838165 15.3924L0.868838 15.7266L1.13844 15.9264C2.81818 17.1714 4.68053 18.1233 6.68582 18.719L7.18892 18.8684L7.50166 18.4469C7.96179 17.8268 8.36504 17.1824 8.709 16.4944L8.71099 16.4904C10.8645 17.0471 13.128 17.0485 15.2821 16.4947C15.6261 17.1826 16.0293 17.8269 16.4892 18.4469L16.805 18.8725L17.3116 18.717C19.3056 18.105 21.1876 17.1751 22.8559 15.9238L23.1224 15.724L23.1528 15.3923C23.5873 10.6524 22.3579 6.53306 19.8947 2.90714L19.7759 2.73227L19.5833 2.64518C18.1437 1.99439 16.6386 1.51826 15.0686 1.25995ZM16.6074 10.7755L16.6074 10.7756C16.5934 11.6409 16.0212 12.1444 15.4783 12.1444C14.9297 12.1444 14.3493 11.6173 14.3493 10.7877C14.3493 9.94885 14.9378 9.41192 15.4783 9.41192C16.0471 9.41192 16.6209 9.93851 16.6074 10.7755ZM8.49373 12.1444C7.94513 12.1444 7.36471 11.6173 7.36471 10.7877C7.36471 9.94885 7.95323 9.41192 8.49373 9.41192C9.06038 9.41192 9.63892 9.93712 9.6417 10.7815C9.62517 11.6239 9.05462 12.1444 8.49373 12.1444Z"
//           strokeWidth="1.5"
//         />
//       </svg>
//     ),
//   },
// ];
